<div class="container p-3">
    <div class="row">
        <h3 class="col">Confirm</h3>
        <div class="col text-end">
            <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
        </div>
    </div>
    <div>
        <p>You are about to send an email to {{emailCount}} user{{((emailCount != 1)?'s':'')}}.</p>
        <p>Please confirm the email count before the messages are sent.</p>
        <p>
            <input class="form-control" type="number" id="enteredEmailCount" name="enteredEmailCount" placeholder="Enter the expected email count" [(ngModel)]="enteredEmailCount" />
        </p>
    </div>
    <div class="row">
        <div class="col mt-2">
            <button type="button" class="btn btn-secondary" (click)="close()">Go Back</button>
        </div>
        <div class="col mt-2 text-end">
            <button *ngIf="enteredEmailCount == emailCount" type="button" class="btn btn-primary" (click)="confirm()">Confirm</button>
            <button *ngIf="enteredEmailCount != emailCount" type="button" class="btn btn-primary disabled" disabled="disabled">Confirm</button>
        </div>
    </div>
</div>
